<template>
<div>
  <section>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="blue"
        grow
        slider-color="cyan accent-4"
      >
        <v-tab key="0">
          <v-icon class="mr-4">fas fa-inbox</v-icon>
          Items
        </v-tab>
        <v-tab key="1">
          <v-icon class="mr-4">fa fa-layer-group</v-icon>
          Inventory levels
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          :key="0"
        >
          <ItemsDataTable></ItemsDataTable>
        </v-tab-item>

        <v-tab-item
          :key="1"
        >
         <InventoryLevelsDataTable></InventoryLevelsDataTable>
        </v-tab-item>
      </v-tabs-items>
  </section>
</div>
</template>

<script>
    import InventoryLevelsDataTable from "./InventoryLevelsDatatable";
    import ItemsDataTable from "./ItemsDataTable";

    export default {
        name: "ManageItems",
        components: {
            InventoryLevelsDataTable,
            ItemsDataTable
        },
        data() {
            return {
                tab: 0,
            }
        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Inventory/ManageItems.vue